import 'css-chunk:src/applications/ProductFulfillmentApp/CreatorProductSelection/components/OrderRequestReview/OrderRequestReview.styles.scss';export default {
  "Wizard": "_Wizard_1fb9e_1",
  "mainContentWrapper": "_mainContentWrapper_1fb9e_6",
  "footer": "_footer_1fb9e_11",
  "footerButton": "_footerButton_1fb9e_21"
};